
<template>
  <!-- eslint-disable -->
  <svg :style="style" :class="classes" data-components="LogoInstagramSvg" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="#fff" d="M12 0C8.745 0 8.325 0 7.05.075 5.775.135 4.905.33 4.14.63c-.795.3-1.455.72-2.13 1.38A5.785 5.785 0 00.63 4.14c-.3.765-.495 1.635-.555 2.91C.015 8.325 0 8.745 0 12s0 3.675.075 4.95c.06 1.275.255 2.145.555 2.91.3.795.72 1.455 1.38 2.13.66.66 1.335 1.08 2.13 1.38.765.3 1.635.495 2.91.555 1.275.06 1.695.075 4.95.075s3.675 0 4.95-.075c1.275-.06 2.145-.255 2.91-.555.795-.3 1.455-.72 2.13-1.38a5.785 5.785 0 001.38-2.13c.3-.765.495-1.635.555-2.91.06-1.275.075-1.695.075-4.95s0-3.675-.075-4.95c-.06-1.275-.255-2.145-.555-2.91-.3-.795-.72-1.455-1.38-2.13A5.785 5.785 0 0019.86.63c-.765-.3-1.635-.495-2.91-.555C15.675.015 15.255 0 12 0zm0 2.16c3.21 0 3.585 0 4.845.075 1.17.06 1.8.255 2.235.42.555.225.96.48 1.38.9.42.42.675.825.9 1.38.165.42.36 1.065.42 2.235.06 1.26.075 1.65.075 4.845s0 3.585-.075 4.845c-.06 1.17-.255 1.8-.42 2.235-.225.555-.48.96-.9 1.38-.42.42-.825.675-1.38.9-.42.165-1.065.36-2.235.42-1.26.06-1.65.075-4.845.075s-3.585 0-4.845-.075c-1.17-.06-1.8-.255-2.235-.42-.555-.225-.96-.48-1.38-.9-.42-.42-.675-.825-.9-1.38-.165-.42-.36-1.065-.42-2.235-.06-1.26-.075-1.65-.075-4.845s0-3.585.075-4.845c.06-1.17.255-1.8.42-2.235.225-.555.48-.96.9-1.38.42-.42.825-.675 1.38-.9.42-.165 1.065-.36 2.235-.42 1.26-.06 1.65-.075 4.845-.075z"/><path fill="#fff" d="M12 15.99a4.004 4.004 0 01-4.004-4.005A3.995 3.995 0 0112 7.98a3.995 3.995 0 014.005 4.005A3.995 3.995 0 0112 15.99zm0-10.155a6.165 6.165 0 100 12.33 6.165 6.165 0 000-12.33zM19.845 5.58a1.44 1.44 0 11-2.88-.001 1.44 1.44 0 012.88 0z"/></svg>
</template>

<script>
import globalMixin from 'Libs/mixins/globalMixin';

export default {
  name: 'LogoInstagramSvg',
  mixins: [globalMixin],
  props: {
    width: {
      type: [String, Number, Boolean],
      default: false
    },
    height: {
      type: [String, Number, Boolean],
      default: false
    },
    original: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    style() {
      const style = {};

      if (this.width) {
        style.width = this.width + 'px';
      }

      if (this.height) {
        style.height = this.height + 'px';
      }

      return style;
    }
  }
};
</script>
